export const SURVEY_CAMPAIGNS = `
  query surveyCampaigns(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $filter: SurveyCampaignFilterInput
  ) {
    surveyCampaigns(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      filter: $filter
    ) {
      __typename
      ... on SurveyCampaign {
        id
        survey_type_id
        survey_type_name
        name
        edition
        start_date
        end_date
        status
        display_status
        delivery_method
        cancelled_at
        cancelled_by_name
        created_by
        recipients
        sent
        pending
        errors
        responded
        late
        pending_responses
        links_generated
        participation
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SURVEY_CAMPAIGN = `
  query surveyCampaign($id: Int!, $tenant_id: Int!) {
    surveyCampaign(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        name
        status
        display_status
        recipients
        links_generated
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SURVEY_CAMPAIGNS_COUNT = `
  query surveyCampaignsCount(
    $tenant_id: Int!
    $filter: SurveyCampaignFilterInput
  ) {
    surveyCampaignsCount(
      tenant_id: $tenant_id
      filter: $filter
    )
  }
`;

export const SURVEY_AUDIENCE_SUMMARY = `
  query surveyAudienceSummary(
    $surveyTypeId: Int!
    $tenant_id: Int!
  ) {
    surveyAudienceSummary(
      surveyTypeId: $surveyTypeId
      tenant_id: $tenant_id
    ) {
      __typename
      ... on SurveyAudienceSummary {
        count
        descriptions
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SURVEY_CAMPAIGN_DISPATCHES = `
  query surveyCampaignDispatches(
    $id: Int!
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $searchText: String
  ) {
    surveyCampaignDispatches(
      id: $id
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      searchText: $searchText
    ) {
      __typename
      ... on SurveyCampaignDispatch {
        id
        contact_id
        firstname
        lastname
        email
        status
        survey_url
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SURVEY_CAMPAIGN_DISPATCHES_COUNT = `
  query surveyCampaignDispatchesCount(
    $id: Int!
    $tenant_id: Int!
    $searchText: String
  ) {
    surveyCampaignDispatchesCount(
      id: $id
      tenant_id: $tenant_id
      searchText: $searchText
    )
  }
`;

export const SURVEY_TYPES = `
  query surveyTypes($tenant_id: Int!) {
    surveyTypes(tenant_id: $tenant_id) {
      __typename
      ... on SurveyType {
        id
        key
        name
        active
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
